var map = {
	"./beyond-green-vineyard.jpg": "5b21",
	"./beyond-green-winery.jpg": "bceb",
	"./climate-smart-vineyard.jpg": "3daa",
	"./climate_smart_winery.jpg": "c2b8",
	"./napa_green_block.jpg": "e7ea",
	"./napa_green_land.jpg": "8d28",
	"./napa_green_vineyard.jpg": "01da",
	"./napa_green_winery-1.jpg": "456c",
	"./napa_green_winery.jpg": "a8f7",
	"./rise-vineyard-logo.jpg": "dacc",
	"./rise_winery.jpg": "fdca",
	"./vineyard-logo.jpg": "4d02"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";